var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"biomeList"},_vm._l((_vm.biomes),function(biome){return _c('router-link',{directives:[{name:"tippy",rawName:"v-tippy"}],key:biome.id,staticClass:"biome",class:{selected: biome == _vm.selectedBiome},attrs:{"to":biome.url(),"title":biome.name}},[_c('BiomeImage',{attrs:{"biome":biome}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2711443b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BiomeList.vue
// module id = 102
// module chunks = 0